import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link2, Plus } from 'lucide-react';
import { Button } from '@ntconsult/aluma-react';
import type { Share, ShareResourceType } from '../../types';
import { CreateLinkForm } from './CreateLinkForm';
import { LinkCard } from './LinkCard';

interface LinksSectionProps {
  resourceType: ShareResourceType;
  resourceId: string;
  linkShares: Share[];
  canManage: boolean;
}

export function LinksSection({
  resourceType,
  resourceId,
  linkShares,
  canManage,
}: LinksSectionProps) {
  const { t } = useTranslation('shares');
  const [creating, setCreating] = useState(false);

  return (
    <section>
      <header className="flex items-center justify-between mb-3">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <Link2 className="w-4 h-4" aria-hidden="true" />
          {t('links.sectionTitle')}
        </h3>
        {canManage && !creating && (
          <Button
            size="sm"
            variant="secondary"
            leftIcon={<Plus className="w-4 h-4" aria-hidden="true" />}
            onClick={() => setCreating(true)}
          >
            {t('links.createCta')}
          </Button>
        )}
      </header>

      {creating && (
        <CreateLinkForm
          resourceType={resourceType}
          resourceId={resourceId}
          onClose={() => setCreating(false)}
        />
      )}

      {linkShares.length === 0 && !creating ? (
        <p className="text-sm text-foreground-muted py-3">
          {t('links.empty')}
        </p>
      ) : (
        <ul className="flex flex-col gap-2">
          {linkShares.map((s) => (
            <LinkCard key={s.id} share={s} canManage={canManage} />
          ))}
        </ul>
      )}
    </section>
  );
}
